import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent, useEffect } from 'react';
import css from './PromotionGamesRoute.module.less';
import PromotionSelector from '@components/PromotionSelector/PromotionSelector';
import { GamesList, GamePromotionEditModal } from '@pages/PromotionPage';
import modals, { IModalsState } from '@stores/modals';
import { useStore } from 'effector-react';
import PromotionGamesFilter from '@components/PromotionGamesFilter';
import * as postSelector from '@stores/postSelector';

const PromotionGamesRoute: FunctionComponent<unknown> = () => {
  const {
    visibleState: { promotion: visible },
    data,
  } = useStore<IModalsState<any>>(modals);

  useEffect(() => {
    postSelector.reset();
  }, [visible]);

  return (
    <div className={css.root}>
      <FilterSidebar className={css.selector}>
        <PromotionSelector />
        <PromotionGamesFilter />
      </FilterSidebar>
      <div className={css.list}>
        <GamesList />
      </div>
      {visible ? <GamePromotionEditModal data={data} /> : null}
    </div>
  );
};

export default PromotionGamesRoute;
